import { getLiteralWithParameters } from 'utils/getLiteral';

const MAX_NAME_LENGTH = 80;
const MAX_DESCRIPTION_LENGTH = 500;

export const validations = {
    name: (value) => {
        if (value?.length > MAX_NAME_LENGTH) {
            return getLiteralWithParameters('error_text_too_long', [MAX_NAME_LENGTH]);
        }
    },
    description: (value) => {
        if (value?.length > MAX_DESCRIPTION_LENGTH) {
            return getLiteralWithParameters('error_text_too_long', [MAX_DESCRIPTION_LENGTH]);
        }
    },
};
